import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Home, Compass } from "lucide-react";

export default function NotFound() {
  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center text-center px-5" data-testid="not-found">
      <div className="w-16 h-16 rounded-2xl bg-brand-emerald/10 flex items-center justify-center mb-6">
        <Compass className="w-8 h-8 text-brand-emerald" />
      </div>
      <h1 className="font-heading font-bold text-5xl text-brand-ink tracking-tight">404</h1>
      <p className="text-brand-muted mt-3 max-w-sm">The page you're looking for doesn't exist or has moved.</p>
      <div className="flex gap-3 mt-6">
        <Link to="/"><Button className="rounded-full bg-brand-emerald hover:bg-brand-emeraldHover"><Home className="w-4 h-4 mr-1.5" /> Home</Button></Link>
        <Link to="/browse"><Button variant="outline" className="rounded-full">Browse Properties</Button></Link>
      </div>
    </div>
  );
}
